export default {
  idioma: '',
  idiomasSuportados: ['pt', 'en', 'de'],
};
